import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { LookupService } from '../../../../services/lookup.service';
import {
  DialogConfig,
  DialogService,
} from '../../../../shared/services/dialog.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { AuthorizationDetailsComponent } from '../../authorizations/authorization-details/authorization-details.component';
import { SectionsService } from '../../../../services/sections.service';
import { ListService } from '../../../../shared/services/list.service';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { TimesheetStaffDeniedReasonsComponent } from '../timesheet-staff-deniedreasons/timesheet-staff-deniedreasons.component';
import { TimesheetStaffAuthDataComponent } from '../timesheet-staff-authdata/timesheet-staff-authdata.component';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { TimesheetStaffErrorcodeComponent } from "../timesheet-staff-errorcode/timesheet-staff-errorcode.component";
import { UserService } from '../../../../services/user.service';
import CommonUtil from '../../../../shared/authorization/common.util';
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';

@Component({
  selector: 'ppl-timesheet-view',
  standalone: true,
  imports: [
    ListTableComponent,
    NzSelectModule,
    NzFormModule,
    FormsModule,
    ButtonComponent,
    NzDividerModule,
    AuthorizationDetailsComponent,
    TimesheetStaffDeniedReasonsComponent,
    TimesheetStaffAuthDataComponent,
    TimesheetStaffErrorcodeComponent,
    DropdownSelectComponent,
  ],
  templateUrl: './timesheet-view.component.html',
  styleUrl: './timesheet-view.component.css',
})
export class TimesheetViewComponent implements OnInit {
  actionButtons: TableRowActionsModel = new TableRowActions({ view: true });
  showTimesheets = false;
  consumer: any;
  entry!: string;
  denyReasons: any;
  listOfOption: any;
  selectedReason = '';
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  pageId: string = PAGE_CONSTANTS.PROVIDER_TIMESHEET_PAGE;
  @ViewChild('denyDialog') denyDialog!: TemplateRef<any>;
  @ViewChild('pendedDialog') pendedDialog!: TemplateRef<any>;
  @ViewChild('deniedDialog') deniedDialog!: TemplateRef<any>;
  @ViewChild('authDialog') authDialog!: TemplateRef<any>;
  @ViewChild('authDataDialog') authDataDialog!: TemplateRef<any>;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  id: any;

  @Input() isProcessed = true;
  @Input() consumerLineData: any;
  @Input() consumers: any;
  providerName: any;
  @Input() providerPplId: any;
  selectedCheckBoxValue: any;
  @Input() providerId: any;
  @Input() payrollScheduleId: any;
  @Input() isViewTimeOff = false;
  @Output() updated = new EventEmitter();
  consumerName: any;
  consumerPPLId: any;
  deleteDialogId: any;
  processingStatusList: any;
  ptoDeleteAllowedStatusList: string[] = ['RP', 'PE', 'SB'];
  programName!: string;
  TSdata: any;
  timeoffData: any;
  additionalCols: any[] = [];
  authDetails: any;
  deniedData: any;
  authData: any;
  statusList: any;
  reasonList: any;
  dispositionReason: any;
  timesheetDisposition: any;
  pendedDialogId: any;
  errorcodeData: any;
  disableEditingPendedTimesheet = false;
  @Input() isReadOnly = false;
  canApproveDeny: boolean = true;

  timeoff_cols = [
    {
      field: 'payrollStartDate',
      header: 'Payroll \nStart Date',
      jsonpath: 'payrollStartDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'payrollEndDate',
      header: 'Payroll \nEnd Date',
      jsonpath: 'payrollEndDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'ptoDate',
      header: 'Event \nDate',
      jsonpath: 'ptoDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'createdDate',
      header: 'Submission \nDate',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    // {
    //   field: 'serviceCode',
    //   header: 'Service \nCode',
    //   jsonpath: 'serviceCode',
    //   isDisplayedAtHeader: 'n',
    //   isSearchable: 'n',
    // },
    {
      field: 'description',
      header: 'Service \nDescription',
      jsonpath: 'description',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatusDesc',
      header: 'Business \nStatus',
      jsonpath: 'businessStatusDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processingStatusDesc',
      header: 'Processing \nStatus',
      jsonpath: 'processingStatusDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceCodeRate',
      header: 'Service \nRate',
      jsonpath: 'serviceCodeRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnits',
      header: 'Billed Units \n(15 Mins \nIncrement)',
      jsonpath: 'billedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnitsInHours',
      header: 'Billed \nUnits (hrs)',
      jsonpath: 'billedUnitsInHours',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidUnits',
      header: 'Paid \nUnits (hrs)',
      jsonpath: 'paidUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  consumer_cols = [
    {
      field: 'serviceDate',
      header: 'Service \nDate',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'createdDate',
      header: 'Submission \nDate',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDescription',
      header: 'Service Description',
      jsonpath: 'serviceDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeIn',
      header: 'Time In',
      jsonpath: 'timeIn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeOut',
      header: 'Time Out',
      jsonpath: 'timeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnits',
      header: 'Billed Units \n(15 Mins \nIncrement)',
      jsonpath: 'billedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnitsInHrs',
      header: 'Billed \nUnits (hrs)',
      jsonpath: 'billedUnitsInHrs',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidUnits',
      header: 'Paid \nUnits (hrs)',
      jsonpath: 'paidUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceRate',
      header: 'Service Rate',
      jsonpath: 'serviceRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'manualReason',
      header: 'Manual Reason',
      jsonpath: 'manualReason',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatus',
      header: 'Business \nStatus',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processingStatus',
      header: 'Processing \nStatus',
      jsonpath: 'processingStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'authNum',
      header: 'Auth \nNumber',
      jsonpath: 'authNum',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  cols = [
    {
      field: 'fromDate',
      header: 'From Date',
      jsonpath: 'fromDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceCodeDescription',
      header: 'Service Description',
      jsonpath: 'serviceCodeDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeIn',
      header: 'Time In',
      jsonpath: 'timeIn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeOut',
      header: 'Time out',
      jsonpath: 'timeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnits',
      header: 'Billed Units \n(15 Mins Increment)',
      jsonpath: 'billedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'status',
      header: 'Status',
      jsonpath: 'status',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  authCols = [
    {
      field: 'clientAuthNumber',
      header: 'Auth Number',
      jsonpath: 'clientAuthNumber',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'usedUnits',
      header: 'Used Units',
      jsonpath: 'usedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  statusCols = [
    {
      field: 'code',
      header: 'Code',
      jsonpath: 'code',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'desc',
      header: 'Description',
      jsonpath: 'desc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  constructor(
    private dateTimeFormatterService: DateTimeFormatterService,
    private lookupService: LookupService,
    private timesheetService: TimesheetService,
    private errorAlertService: ErrorAlertService,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService,
    private sectionService: SectionsService,
    private listService: ListService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.id = this.userService.getSelectedLead();
    const selectedProgram = this.userService.getSelectedProgram();
    this.statusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.reasonList = this.lookupService.getLookupValue('Manual Entry reason');
    this.programName = selectedProgram?.program_code ?? '';
    this.dispositionReason = this.lookupService.getLookupValue('Disposition Reason');
    this.timesheetDisposition = this.lookupService.getLookupValue('TimeSheet Disposition');
    this.programName = selectedProgram?.program_code ?? '';
    const userDetails = this.userService.getUserDetails();
    const isFIAdmin = this.userService.isSelectedRole('FI Admin') && userDetails?.usertype_lkp === 'FI';
    const decisionDetailsAuthorizedRoles = ["PPL Admin", "Enrollment Specialist", "PPL Staff Tier 1", "Paper Timesheet Processor",
      "Fulfillment Staff", "PAVTraining", "PAVAdmin", "Compliance", "BAVAdmin", "PPL HR Staff", "FI Admin", "CDPAP Facilitator Tier 2", "State Admin"];
    const decisionDetailsAuthorizedLookup = ["FMS", "FI", "State"];
    if (userDetails?.usertype_lkp) {
      const isDecisionDetailsUserAuth = this.userService.isSelectedRole(decisionDetailsAuthorizedRoles)
        && decisionDetailsAuthorizedLookup.includes(userDetails.usertype_lkp);

      if (isDecisionDetailsUserAuth) {
        this.consumer_cols = [
          ...this.consumer_cols,
          {
            field: 'consumerDecisionDate',
            header: 'Decision \nTimestamp',
            jsonpath: 'consumerDecisionDate',
            isDisplayedAtHeader: 'y',
            isSearchable: 'n',
          },
          {
            field: 'consumerDecisionBy',
            header: 'Decision \nBy',
            jsonpath: 'consumerDecisionBy',
            isDisplayedAtHeader: 'y',
            isSearchable: 'n',
          }
        ];
      }
    }
    this.canApproveDeny = isFIAdmin ? false : true;
    this.consumerLineData = this.consumerLineData?.map((item: any) => {
      item.billedUnitsInHrs = item.billedUnits ? (item.billedUnits * 15) / 60 : null;
      item.paidUnits = item.paidUnits === 0 || item.paidUnits ? (item.paidUnits * 15) / 60 : null;
      item.createdDate = this.dateTimeFormatterService.formatDateTimeNoSeconds(item.createdDate);
      item.consumerDecisionDate = this.dateTimeFormatterService.formatDate(item.consumerDecisionDate, 'MM/dd/yyyy');
      const reason = this.reasonList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === item.manualReasonLkp;
      });

      if (reason) {
        item.manualReason = reason.lkpValueName;
      }
      if (typeof item.mealBreakTaken === 'boolean') {
        item.mealBreakTaken = item.mealBreakTaken ? 'Yes' : 'No';
      }

      if (STATIC_DATA.STATUS_FOR_AUTH.includes(item.businessStatusLkp)) {
        return {
          ...item,
          authNum: 'View',
        };
      }

      return item;
    });

    if (this.consumerLineData) {
      this.providerName = this.consumerLineData[0]?.providerName;
    }

    this.entry = this.userService.getLeadEntry() ?? '';
    if (this.entry === 'participantEnrollment') {
      if (!this.isProcessed) {
        this.consumer_cols = this.consumer_cols.filter((item: { field: string }) => {
          return item.field !== 'authNum';
        });
      }
      this.consumer_cols = [
        ...this.consumer_cols,
        {
          field: 'mealBreakTaken',
          header: 'Meal Break \nTaken',
          jsonpath: 'mealBreakTaken',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'description',
          header: 'Reason',
          jsonpath: 'description',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        },
        {
          field: 'remarks',
          header: 'Comments',
          jsonpath: 'remarks',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        }
      ];
    }
    if (this.entry === 'providerEnrollment' && !this.isProcessed) {
      this.cols = this.cols.filter((item: any) => {
        return item.field !== 'status' && item.field !== 'authNum';
      });
    }
    this.denyReasons = this.lookupService.getLookupValue(
      'consumer_ts_denial'
    );
    this.listOfOption = this.denyReasons.map((item: any) => item.lkpValueName);

    if (this.isViewTimeOff && this.entry === 'providerEnrollment') {
      this.fetchTimeOffTimesheets();
    }

    this.setPageAccess();
  }

  fetchTimeOffTimesheets() {
    this.timesheetService
      .getTimeOffTimesheets(this.programName, this.providerId)
      .subscribe((data: any) => {
        const response = data.responsedata;

        response.sort((a: any, b: any) => {
          const rank = (item: any) => {
            if (this.ptoDeleteAllowedStatusList.includes(item.processingStatusLkp)) {
              return 0; // highest priority
            }
            if (item.serviceCode === 'PTO') {
              return 1; // second priority
            }
            return 2; // lowest priority
          };

          return rank(a) - rank(b);
        });

        response.forEach((e: any) => {
          e.actions = {};
          const businessStatus = this.statusList.find((gen: LookupValueItem) => {
            return gen.lkpValueCode === e.businessStatus;
          });

          const processingStatus = this.processingStatusList.find((gen: LookupValueItem) => {
            return gen.lkpValueCode === e.processingStatusLkp;
          });

          if (businessStatus) {
            e.businessStatusDesc = businessStatus.lkpValueName;
          }

          if (processingStatus) {
            e.processingStatusDesc = processingStatus.lkpValueName;

            if (this.ptoDeleteAllowedStatusList.includes(processingStatus?.lkpValueCode) && (e.serviceCode === 'PTO' || e.serviceCode === 'UPST')) {
              if (this.canApproveDeny) {
                e.actions.cancel = true;
              }
            }
          }

          e.billedUnitsInHours = e.billedUnits ? (e.billedUnits * 15) / 60 : null;
          e.paidUnits = e.paidUnits ? (e.paidUnits * 15) / 60 : null;
        });

        this.timeoffData = response;
      });
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(
        pageConfig,
        this.pageId
      );
      this.actionsToBeHidden = this.authUtility.getHiddenActions(
        pageConfig,
        this.pageId
      );
    }
    this.isPageRestrictionLoaded = true;
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService
        .fetchPageAuthorization(this.programName, this.pageId, 'LIST')
        .subscribe((response) => {
          this.setRestrictions(response);
        });
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  consumerValueChange(event: any) {
    this.consumerName = event.consumerFullName;
    this.consumerPPLId = event.consumerPplId;
    this.showTimesheets = true;
    const payload = {
      programCode: this.programName,
      providerId: this.providerId,
      participantId: event.consumerId,
      tasMasterPayrollScheduleId: this.payrollScheduleId,
    };
    this.timesheetService
      .getProviderTsDetails(payload)
      .subscribe((data: any) => {
        this.TSdata = data.responsedata.map((item: any) => {
          // item.timeIn = this.convertTo12HourFormat(item.timeIn);
          // item.timeOut = this.convertTo12HourFormat(item.timeOut);
          return item;
        });

        this.showTimesheets = true;
      });
  }

  convertTo12HourFormat(time: string): string {
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const adjustedHour = hours % 12 || 12;
    const formattedTime = `${adjustedHour}:${minutes < 10 ? '0' + minutes : minutes} ${period}`;
    return formattedTime;
  }

  denyPayroll() {
    if (!this.selectedCheckBoxValue?.length) {
      const errorMessage = 'Please select lines for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }
    if (this.selectedCheckBoxValue.filter((entry: any) => entry.businessStatusLkp !== 'AC')?.length) {
      const errorMessage = 'Payrolls can only be denied if they are currently waiting for consumer approval.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }
    this.openDenyPopup();
  }

  approvePayroll() {
    console.log('selectedCheckBoxValue---', this.selectedCheckBoxValue);
    if (!this.selectedCheckBoxValue?.length) {
      const errorMessage = 'Please select lines for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }
    if (this.selectedCheckBoxValue.filter((entry: any) => entry.businessStatusLkp !== 'AC')?.length) {
      const errorMessage = 'Payrolls can only be approved if they are currently waiting for consumer approval.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }
    this.updateStatus('GP', this.selectedCheckBoxValue);
  }

  getTasTimesheetlineDetailIds(data: any[]): number[] {
    return data.map((item) => item.tasTimesheetlineDetailId);
  }

  createUpdatePayload(status: string, data?: any) {
    return {
      timesheetIds: this.getTasTimesheetlineDetailIds(data),
      status: status,
      programCode: this.programName,
      participantId: data[0]?.participantId || null,
      providerId: data[0]?.providerId || null,
      tasMasterPayrollScheduleId: null,
      remarks: this.selectedReason,
    };
  }

  updateStatus(status: string, data?: any) {
    const payload = this.createUpdatePayload(status, data);
    this.timesheetService
      .updateStatusConsumerTimesheet(payload, status)
      .subscribe((data: any) => {
        if (data.status === 200) {
          this.updated.emit(true);
        }
        console.log('after update status timesheet', data);
      });
  }

  selectionChanged(event: any) {
    this.selectedCheckBoxValue = event;
  }

  openDenyPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Deny Payroll',
      isOkText: 'Deny',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.denyDialog,
      dialogConfig,
      () => this.handleOk(),
      () => this.handleDenyCancel()
    );
  }

  handleDenyCancel() {
    this.selectedReason = '';
  }

  handleOk() {
    this.updateStatus('CD', this.selectedCheckBoxValue);
  }

  action(event: any): void {
    if (event?.action === 'cancel') {
      this.openConfirmationPopup(event);
    }
  }

  openConfirmationPopup(event: any) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Yes',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.deleteDialogId = this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteTimesheet(event),
      () => this.closeDeleteDialog()
    );
  }

  deleteTimesheet(event: any): void {
    if (event?.data?.timeSheetDetailId) {
      const deleteTimesheetsPayload = { programCode: this.programName, timesheetLineDetailIds: [event.data.timeSheetDetailId] };

      this.timesheetService.deleteTimesheet(deleteTimesheetsPayload)
        .subscribe((response: any) => {
          if (response.status === 200) {
            this.fetchTimeOffTimesheets();
          } else {
            console.error('Error deleting timesheet:', response);
          }
        });
    } else {
      console.log(`Timesheet detail id is missing.`);
    }
  }

  closeDeleteDialog() {
    if (this.deleteDialogId) {
      this.dialogSvc.closeDialog(this.deleteDialogId);
      this.deleteDialogId = null;
    }
  }

  showAuthDetails(event: any) {
    if (event.clientAuthNumber) {
      this.authDetails = event;
      this.openAuthDialog();
    }
  }

  openAuthDialog() {
    this.sectionService.setFlow('authorizations');
    this.userService.setLeadEntry('authorizations');
    this.userService.setSelectedLead(this.authDetails.tasAuthorizationDetailId);
    const dialogConfig: DialogConfig = {
      title: `Auth Details for ${this.authDetails.clientAuthNumber}`,
      isOkText: 'Deny',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openAuthDataDialog() {
    const dialogConfig: DialogConfig = {
      title: `Authorizations`,
      isOkText: 'Deny',
      size: 'large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDataDialog,
      dialogConfig,
      () => this.handleAuthDataCancel(),
      () => this.handleAuthDataCancel()
    );
  }



  handleAuthDataCancel() {

  }

  handleCancel() {
    this.sectionService.setFlow('participantEnrollment');
    this.userService.setLeadEntry('participantEnrollment');
    this.userService.setSelectedLead(this.id);
  }

  rowClickedTs(event: any) {
    if (event.col?.field === 'authNum') {
      this.timesheetService
        .getAuthDetails(this.programName, event.event.timesheetLineId)
        .subscribe((data: any) => {
          this.authData = data.responsedata;
          this.openAuthDataDialog();
        });
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && ['Pended'].includes(event.event.processingStatus)) {
      this.handlePendedTimesheet(event, false);
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && CommonUtil.hasInfoStatus(event.event.processingStatus)) {
      this.handlePendedTimesheet(event, true);
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && event.event.processingStatus === 'Denied') {
      const payload = {
        pageName: 'timesheet-processCode',
        programCode: this.programName,
        condition: 'and',
        recordsPerPage: 20,
        startingPageNumber: 1,
        searchParam: [
          {
            jsonPath: 'timesheetId',
            value: event.event.timesheetLineId,
            operator: 'Equal',
          },
        ],
        orderByColumn: ['id'],
        orderBy: ['desc'],
      };
      this.listService
        .getListData(payload, 'claims')
        .subscribe((data: any) => {
          this.deniedData = data.responsedata;
          this.deniedData.forEach((e: any) => {
            if (e.reasonLkp) {
              e.reason = this.dispositionReason.filter((d: any) => d.lkpValueCode == e.reasonLkp)[0].lkpValueName;
            }

            if (e.dispositionLkp) {
              e.disposition = this.timesheetDisposition.filter((d: any) => d.lkpValueCode == e.dispositionLkp)[0].lkpValueName
            }
          });
          this.openDeniedDialog();
        });
    }
  }

  handlePendedTimesheet(event: any, allowEdit: boolean) {
    this.disableEditingPendedTimesheet = this.isReadOnly ? true : allowEdit;
    const timesheetLineId = event.event.timesheetLineId;
    console.log("timesheetLineId", timesheetLineId);
    const filters: any = [
      {
        jsonPath: "timesheetId",
        value: timesheetLineId,
        operator: "Equal"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'timesheet-processCode',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.errorcodeData = data.responsedata;
        this.openPendedDialog(`${event.event.processingStatus} Timesheet`);
      });
  }

  openDeniedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Denied Timesheet`,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.deniedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  buildRequestPayload(pageName: string, searchParams: []) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: ['desc'],
    };
    return payload;
  }

  openPendedDialog(title: string) {
    const dialogConfig: DialogConfig = {
      title: title,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.pendedDialogId = this.dialogSvc.openDialog(
      this.pendedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  onSaveAdjustment(event: any) {
  }

  rowClicked(event: any) {
    console.log("Row Clicked!!!!", event);
  }
}
